import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { useSubRoutes, useExactRedirect, usePermissionTabs } from 'hooks';
import { Header, Tabs, Container, PageContent, Alerts, PrivateComponent } from 'components';
import { Margin } from 'styled-components-spacing';
import { globalPropTypes } from 'helpers';
import { useTranslation } from 'react-i18next';

const breadcrumbs = [
  {
    title: 'navigation.breadcrumbs.yc.projects',
    url: '/yc/projects',
  },
];

const initialTabs = [
  {
    title: 'navigation.tabs.yc.projects.planning',
    path: '/yc/projects/planning',
    key: 'planning',
  },
  {
    title: 'navigation.tabs.yc.projects.running',
    path: '/yc/projects/running',
    key: 'running',
  },
  {
    title: 'navigation.tabs.yc.projects.completed',
    path: '/yc/projects/completed',
    key: 'completed',
  },
];

const Projects = ({ routes, bar, userPermissions }) => {
  const { t } = useTranslation();
  const [renderSubRoutes] = useSubRoutes(routes);

  const [tabs, firstTabPath] = usePermissionTabs(initialTabs, routes, userPermissions, bar);
  const [renderExactRedirect] = useExactRedirect('/yc/projects', firstTabPath);

  return (
    <>
      <Header
        breadcrumbs={breadcrumbs}
        title={t('page.yc.projects.title')}
        renderActions={({ Button: ButtonRender }) => (
          <PrivateComponent
            permissions={{
              roles: ['yc_project_manage'],
            }}
          >
            <ButtonRender secondary as={Link} to="/yc/project/create">
              {t('page.yc.projects.createButton')}
            </ButtonRender>
          </PrivateComponent>
        )}
      />
      <Tabs items={tabs} />
      {renderExactRedirect()}
      <PageContent>
        <Container>
          <Margin bottom={{ md: 48 }}>
            <Alerts type="yc" />
          </Margin>
          {renderSubRoutes()}
        </Container>
      </PageContent>
    </>
  );
};

Projects.propTypes = {
  routes: PropTypes.arrayOf(globalPropTypes.RoutePropTypes),
  bar: PropTypes.shape({
    planning: PropTypes.number.isRequired,
    running: PropTypes.number.isRequired,
    completed: PropTypes.number.isRequired,
  }).isRequired,
  userPermissions: globalPropTypes.UserPermissions.isRequired,
};

Projects.defaultProps = {
  routes: [],
};

const mapStateToProps = ({ yc, user }) => ({
  bar: yc.projects.bar,
  userPermissions: user.userPermissions,
});

export default connect(mapStateToProps, null)(Projects);
